export enum CheckboxAlign {
  Left = 'left',
  Right = 'right'
}

export enum CheckboxSize {
  SM = 'sm',
  RG = 'rg',
}

export enum CheckboxFailedType {
  None = 'none',
  Error = 'error',
  Warning = 'warning',
}

export interface CheckboxText {
  Label: string;
  Bold?: boolean;
}
